import React from 'react'
import { BG_IMG_URL} from '../utils/Constants'
import { DetailsContainer } from './DetailsContainer'
import { useSelector } from 'react-redux'
import MovieList from './MovieList'
import useDetails from '../hooks/useDetails'
import useCast from '../hooks/useCast'
import useRecomendedMovies from '../hooks/useRecomended'
import CastDisplay from './CastDisplay'
import VideoModel from './VideoModel'


const DetailsMovie = ({movie_id}) => {
  useDetails(movie_id);
  useCast(movie_id);
  
  useRecomendedMovies(movie_id);
  const movies = useSelector((store)=> store.movies)
  const movieDetails = useSelector((store)=> store.details.MovieDetails)
  const popUps = useSelector((store)=> store.details.PopUp)
  
  return (
    <div >
      <div className='fixed'>
          <img className="h-screen object-cover sm:h-screen sm:object-cover md:h-screen md:w-screen" src= {BG_IMG_URL + movieDetails?.backdrop_path} alt="Bg-img" />
      </div>   
     
      <div className='absolute flex flex-wrap justify-items-center md:inset-x-1/4 inset-0 md:mt-10 mt-32'> 
            <DetailsContainer />

           {popUps? <VideoModel Moviename={movieDetails?.original_title} tral_id={movie_id}/> : " "}
            
            
      <div className='overflow-x-scroll' >
            <MovieList title ={'Recommended'} Movies={movies?.RecomendedMovies}/>
            <CastDisplay/>
      </div>
      </div>   
    </div>
  )
}

export default DetailsMovie